import React from "react";
import { Container, Card, Form, Row, Col, Button } from "react-bootstrap";
import UserLayout from "../components/UserLayout";

const UpdateUser = () => {
  return (
<UserLayout>
<Container className="mt-5">
      <Card className="shadow-sm p-4">
        <h4 className="text-center text-primary mb-3">
          Cập nhật thông tin người dùng
        </h4>

        {/* Thông tin khách hàng */}
        <Card className="mb-3 p-3 border-0 shadow-sm">
          <h5 className="mb-2">Thông tin</h5>
          <Form.Group as={Row} className="mb-2">
            <Form.Label column sm="2">
              Mã KH
            </Form.Label>
            <Col sm="4">
              <Form.Control type="text" placeholder="Nhập mã khách hàng" />
            </Col>
          </Form.Group>
        </Card>

        {/* Bảng giá */}
        <Card className="p-3 border-0 shadow-sm">
          <h5 className="mb-3">Bảng giá</h5>

   
<Row className="mb-3">
  <Col md={2}>
  
      <h6 className="mb-2">TMDT</h6>
   
  </Col>
  <Col md={5}>
    <Card className="p-3 border rounded">
    <Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className="me-2 mb-0">0-16 </Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ kg</Form.Label>
  </Col>

</Row>

<Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className=" mb-0">10-100</Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ kg</Form.Label>
  </Col>
  </Row>
    </Card>
  </Col>
  <Col md={5}>
    <Card className="p-3 border rounded">
    <Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className="me-2 mb-0">0-10 </Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ M3</Form.Label>
  </Col>
</Row>

<Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className=" mb-0">10-100</Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/  M3</Form.Label>
  </Col>
</Row>
    </Card>
  </Col>
</Row>

          {/* Hàng Tiểu ngạch */}
<Row className="mb-3">
  <Col md={2}>
   
      <h6 className="mb-2">Tiểu ngạch</h6>
    
  </Col>
  <Col md={5}>
    <Card className="p-3 border rounded">
      
      <Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className="me-2 mb-0">0-16 </Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ kg</Form.Label>
  </Col>
</Row>

<Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className=" mb-0">10-100</Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ kg</Form.Label>
  </Col>
</Row>
    </Card>
  </Col>
  <Col md={5}>
    <Card className="p-3 border rounded">
    <Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className="me-2 mb-0">0-10 </Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold"> / M3</Form.Label>
  </Col>
</Row>

<Row className="mb-2">
  
  <Col xs="4" className="d-flex align-items-center">
    <Form.Label className=" mb-0">10-100</Form.Label>
  </Col>
  <Col xs="6">
    <Form.Control type="text" />
  </Col>
  <Col xs="2" className="d-flex align-items-center">
    <Form.Label className="fw-bold">/ M3</Form.Label>
  </Col>
</Row>
    </Card>
  </Col>
</Row>

        </Card>

        {/* Nút cập nhật và quay lại */}
        <div className="text-center mt-4">
          <Button variant="primary" className="me-2">
            Cập nhật
          </Button>
          <Button variant="secondary">Quay lại</Button>
        </div>
      </Card>
    </Container>
</UserLayout>
  );
};

export default UpdateUser;
